//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		name: 'PersonalCenter',
		data() {
			return {
				avatar: "/static/head.png", // 默认头像
				username: '',
				organization: '',
				points: 0,
				level: '',
				showLogout: false,
				Sign: false, //当天是否签到
				isLogin: false,
			}
		},
		created() {
			this.isLogin = this.GLOBAL.isLogin;
		},
		mounted() {
			this.LOGINURL = apiConfig.LOGINURL;
			if (this.isLogin) {
				this.getScore();
				this.LoginAndSign();
			}
		},
		methods: {
			GotoLogin() {
				var hrefUrl = apiConfig.WEBURL;
				//var hrefUrl = "localhost:8080";
				hrefUrl = this.LOGINURL + encodeURIComponent(hrefUrl);
				location.href = hrefUrl;
			},
			showLogoutDialog() {
				this.showLogout = true;
			},
			handleLogout() {
				// 这里可以添加退出登录逻辑
				this.showLogout = false;
				this.GLOBAL.isLogin = false;
				this.isLogin = false;

				var HasLoginOut = localStorage.getItem("HasLoginOut");
				var orgID = localStorage.getItem("orgId");

				localStorage.clear();


				if (HasLoginOut == "true") {
					this.$api.GetLoginOut(orgID)
						.then((res) => {
							if (res.data.Status != 0) {
								this.TouristLogin();
							} else {
								localStorage.clear();
								location.href = res.data.Data;
							}
						})
				} else {
					this.TouristLogin();
				}
			},
			TouristLogin: function() {
				_this.$api.TouristLogin()
					.then((response) => {
						if (response.data.Status != 0) {
							return false;
						}
						var json = response.data.Data;
						if (json.IsVisitor) {
							//游客
							var role = [{
								"id": "4",
								"item": "auser",
								"isSysIn": null,
								"description": "不属于机构IP段内，也没有注册的临时用户",
								"addTime": "1505182729",
								"projectNo": _this.$api.PROJECTNO,
								"name": "匿名用户"
							}];
						} else {
							var role = [{
								"id": "3",
								"item": "tuser",
								"isSysIn": null,
								"description": "属于授权机构IP段内的但是未注册的临时用户",
								"addTime": "1505182729",
								"projectNo": _this.$api.PROJECTNO,
								"name": "机构临时用户"
							}];
						}
						var viewVideo = false; //true可以无限制看视频

						var item = "";
						var roleList = role;
						if (roleList.length > 0) {
							item = roleList[0].item;
						}
						//是否可以无限制观看视频
						if (item != "iuser" && item != "auser") {
							viewVideo = true;
						}
						_this.GLOBAL.viewVideo = viewVideo;
					})
			},
			//获取积分
			getScore: function() {
				if (localStorage.getItem("userName") != "" && localStorage.getItem("userName") != null) {

/* 					if (localStorage.getItem("headImg") != "") {
						var img = localStorage.getItem("headImg");
					} else {
						var img = "/static/head.png";
					} */

					this.username = localStorage.getItem("userName");
					this.organization = localStorage.getItem("orgnam");

					this.$api.GetScore()
						.then((data) => {
							if (data.data.Status == 0) {
								var js = data.data.Data;


								this.points = js.totalScore;
								this.level = js.gradeName;
							}

						})


				}

			},
			//点击签到
			clickSign: function() {
				if (this.Sign) {
					alert("已经签到过了")
				} else {
					const today = new Date().toDateString();
					localStorage.setItem("signDt", JSON.stringify({
						value: 1,
						date: today
					}));
					this.Sign = true;
				}
			},
			//判断是否签到 以及 登录加积分
			LoginAndSign: function() {
				const dataStr = localStorage.getItem("signDt");
				if (!dataStr) return null;

				try {
					const data = JSON.parse(dataStr);
					const today = new Date().toDateString();

					if (data.date === today) {
						this.Sign = true;
					} else {
						localStorage.removeItem("signDt");
					}
				} catch (e) {
					localStorage.removeItem("signDt");
				}
			},
			goToPage(e) {
				if (this.isLogin) {
					this.$router.push(e);
				} else {
					alert("请先登录");
				}

			}
		}
	}



// WEBPACK FOOTER //
// ./src/views/Personal.vue